import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { CertificationService } from '../croisement-référentiel/certification.service';
import { Certification } from '../croisement-référentiel/models/certification';
import { CertificationStore } from '../croisement-référentiel/store/certification.store';
import { BlocCompétencesStore } from '../bloc-competences/store/bloc-compétences.store';

export const certificationResolver: ResolveFn<Observable<Certification>> = (route) => {
  const store = inject(CertificationStore);
  const service = inject(CertificationService);
  const blocStore = inject(BlocCompétencesStore);
  const codeFiche = route.params['codeFiche'] as string;
  const slugRef = route.params['slugRef'] as string;

  return service.parCodeFiche(codeFiche, slugRef.split('-')[0]).pipe(
    tap((certification) => {
      store.ajouterCertification({ certification });
      store.selectionerCertification({ codeFiche: certification.codeFiche });
      blocStore.chargerBlocs({ blocs: certification.blocsCompetences });
    }),
  );
};
